import axios, { AxiosResponse } from 'axios';
import type {
  AdminMenuItemCloneRequest,
  AdminMenuItemCloneResponse,
  AdminMenuItemDeleteRequest,
  AdminMenuItemDeleteResponse,
  AdminMenuItemListChildrenRequest,
  AdminMenuItemListChildrenResponse,
  AdminMenuItemListRequest,
  AdminMenuItemListResponse,
  AdminMenuItemNamesListRequest,
  AdminMenuItemNamesListResponse,
  AdminMenuItemUpdateRequest,
  AdminMenuItemUpdateResponse,
  MenuId,
  MenuItemValue,
} from '@/venit/services/model/techpubs-cms';
import { TablePage } from '@/shared/TablePage';

export default class MenuManagementService {
  /** Pobranie listy menu tempate'ów */
  public list(request: AdminMenuItemListRequest): Promise<AxiosResponse<AdminMenuItemListResponse>> {
    return axios.post<AdminMenuItemListResponse>('/api/admin/menu/list', request);
  }

  public listChildren(request: AdminMenuItemListChildrenRequest): Promise<AxiosResponse<AdminMenuItemListChildrenResponse>> {
    return axios.post<AdminMenuItemListChildrenResponse>('/api/admin/menu/list-children', request);
  }

  public listNames(request: AdminMenuItemNamesListRequest): Promise<AxiosResponse<AdminMenuItemNamesListResponse>> {
    return axios.post<AdminMenuItemNamesListResponse>('/api/admin/menu/list-names', request);
  }

  public updateMenu(request: AdminMenuItemUpdateRequest): Promise<AxiosResponse<AdminMenuItemUpdateResponse>> {
    return axios.put<AdminMenuItemUpdateResponse>('/api/admin/menu/update', request);
  }

  public deleteMenu(request: AdminMenuItemDeleteRequest): Promise<AxiosResponse<AdminMenuItemDeleteResponse>> {
    return axios.post<AdminMenuItemDeleteResponse>('/api/admin/menu/delete', request);
  }

  public cloneMenu(request: AdminMenuItemCloneRequest): Promise<AxiosResponse<AdminMenuItemCloneResponse>> {
    return axios.post<AdminMenuItemCloneResponse>('/api/admin/menu/clone', request);
  }

  public refreshMenu(parentId: number, lang: string): Promise<AxiosResponse<MenuItemValue[]>> {
    return axios.post<MenuItemValue[]>('/api/user/menu/refresh', {
      lang,
      parentId,
    });
  }

  async loadMenuValueById(menuId: MenuId): Promise<MenuItemValue> {
    const menuListRequest: AdminMenuItemListRequest = {
      page: new TablePage(1),
      criteria: {
        id: menuId.id,
        actionType: null,
        active: null,
        contentLayout: null,
        name: null,
        parentId: null,
      },
    };
    const response = await this.list(menuListRequest);
    return response.data.list.pageContent[0];
  }
}
